import ObjectIdsPage from './objectIds';

export default ObjectIdsPage;
